import { getMapConfig } from '../../domain/maps.js';
import { createAltarMeshes, syncAltarMeshes } from '../scene/altarSceneManager.js';
import {
  CylinderGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  PointLight,
  SphereGeometry
} from 'three';
import { buildRelicMeshEntries, syncRelicMeshes } from '../scene/relicSceneManager.js';
import { summarizeRelicPadMeshes } from '../scene/relicPadDisc.js';

/**
 * mapObjectivesController — Presentation owner of altar/relic meshes (P3-04b).
 * Match clock is MatchRuntime (P3-01); capture sim is GameOrchestrator.
 */
export function createMapObjectivesController({
  scene,
  globalObj = typeof window !== 'undefined' ? window : null
}) {
  let altars = [];
  let relics = [];
  let meshEntries = [];
  let relicEntries = [];

  function clearMeshes() {
    meshEntries.forEach(entry => {
      if (entry.group && scene) scene.remove(entry.group);
    });
    relicEntries.forEach(entry => {
      if (entry.group && scene) scene.remove(entry.group);
    });
    meshEntries = [];
    relicEntries = [];
  }

  function wireRelicPadHook() {
    const g = globalObj || (typeof window !== 'undefined' ? window : null);
    if (g) g.__debugRelicPads = () => summarizeRelicPadMeshes(relicEntries);
  }

  function loadFromMap(mapId) {
    clearMeshes();
    const config = getMapConfig(mapId);
    altars = config.altars ? JSON.parse(JSON.stringify(config.altars)) : [];
    relics = config.relics ? JSON.parse(JSON.stringify(config.relics)) : [];
    if (altars.length > 0 && scene) {
      meshEntries = createAltarMeshes(altars);
      meshEntries.forEach(entry => scene.add(entry.group));
    }
    if (relics.length > 0 && scene) {
      relicEntries = buildRelicMeshEntries(relics, {
        Group,
        Mesh,
        MeshStandardMaterial,
        PointLight,
        SphereGeometry,
        CylinderGeometry
      });
      relicEntries.forEach(entry => scene.add(entry.group));
    }
    wireRelicPadHook();
  }

  wireRelicPadHook();

  function syncVisuals(tSec) {
    const nowSec = Number.isFinite(tSec)
      ? tSec
      : (typeof performance !== 'undefined' ? performance.now() : Date.now()) / 1000;
    syncAltarMeshes(meshEntries, altars);
    syncRelicMeshes(relicEntries, relics, { tSec: nowSec });
  }

  return {
    loadFromMap,
    syncVisuals,
    getAltars: () => altars,
    getRelics: () => relics,
    setRelics(updated) { relics = updated; }
  };
}
